import React, { useEffect, useState } from 'react';
import {
	Table,
	Status,
	EditInput,
	SendButton,
	CenteredStatusCell,
	Circle,
	TableContainer,
} from './DataTable.style';
import { sendEmailtoAliasOwners, updateMailforAlias } from 'utils/apiRequests';
import ClientNameModal from '../Modal/ClientNameModal';
import { ApInput } from '@alixpartners/ui-components';
import Toast from 'components/Toast/Toast';
import { NotificationTypes } from 'components/Toast/constants';
const toastTime = 15000;
const DataTable = ({ data }) => {
	const [rows, setRows] = useState(data);
	const [clientName, setClientName] = useState('');
	const [row, setrow] = useState(null);
	const [showClientModal, setShowClientModal] = useState(false);
	const [toasts, setToasts] = useState([]);

	useEffect(
		() => {
			setRows(data.map(d => ({ ...d, edited: false })));
		},
		[data]
	);

	const handleEmailChange = async (e, id) => {
		const updatedRows = rows.map(
			row =>
				row.id === id ? { ...row, email_id: e.target.value, edited: true } : row
		);
		setRows(updatedRows);
	};

	const handleSendMail = async () => {
		// Placeholder for sending mail logic
		await sendEmailtoAliasOwners({
			...row,
			email: row.email_id,
			client_Name: clientName,
		});
		setShowClientModal(false);
		showToast('Mail Sent Successfully', NotificationTypes.success);
	};

	const renderStatus = status => {
		return (
			<Status status={status ? 'completed' : 'pending'}>
				<Circle status={status ? 'completed' : 'pending'} />
				{status ? (
					<span style={{ width: '100px' }}>Completed</span>
				) : (
					<span style={{ width: '100px' }}>Pending</span>
				)}
			</Status>
		);
	};
	const handleEmailUpdate = async (id, edited) => {
		if (edited) {
			await updateMailforAlias(rows.find(row => row.id === id));
			const updatedRows = rows.map(
				row => (row.id === id ? { ...row, edited: false } : row)
			);
			setRows(updatedRows);
		}
	};
	const handleRowClickData = currentRow => {
		setrow(currentRow);
		setShowClientModal(true);
	};
	const showToast = (message, status) => {
		const newToast = {
			id: Date.now(),
			message,
			status,
		};

		setToasts(prevToasts => [...prevToasts, newToast]);

		setTimeout(() => {
			setToasts(prevToasts =>
				prevToasts.filter(toast => toast.id !== newToast.id)
			);
		}, toastTime + 500);
	};
	return (
		<>
			<TableContainer>
				{toasts.map(toast => (
					<Toast
						key={toast.id}
						message={toast.message}
						status={toast.status}
						time={toastTime}
					/>
				))}
				{showClientModal && (
					<ClientNameModal
						onClose={() => setShowClientModal(false)}
						title={'Client Name'}
						onSubmit={handleSendMail}
						clientName={clientName}
					>
						<div style={{ display: 'flex', margin: '20px' }}>
							<label style={{ marginTop: '9px' }}>Client Name:</label>
							<ApInput
								value={clientName}
								placeholder="Enter Client Name"
								onChange={e => setClientName(e)}
								required
							/>
						</div>
					</ClientNameModal>
				)}
				<Table>
					<thead>
						<tr>
							<th>ID</th>
							<th>Alias Name</th>
							<th>Envivorment URL</th>
							<th>Email ID</th>
							<th>Survey Form Status</th>
							<th>Email Notification Status</th>
							<th>Benchmark Push Status</th>
							<th>Action</th>
						</tr>
					</thead>
					<tbody>
						{rows.map(row => (
							<tr key={row.id}>
								<td>{row.id}</td>
								<td>{row.alias_name}</td>
								<td>{row.environment_url}</td>
								<td>
									<span style={{ display: 'flex' }}>
										<EditInput
											type="email"
											value={row.email_id || ''}
											onChange={e => handleEmailChange(e, row.id)}
											placeholder="Enter email"
										/>
										<span
											style={{
												margin: 'auto',
												paddingLeft: '5px',
												cursor: `${row.edited ? 'pointer' : 'not-allowed'}`,
											}}
											onClick={() => handleEmailUpdate(row.id, row.edited)}
										>
											<svg
												width="15"
												height="15"
												viewBox="0 0 32 32"
												version="1.1"
												xmlns="http://www.w3.org/2000/svg"
											>
												<g
													id="Page-1"
													stroke={`${row.edited ? 'green' : 'grey'}`}
													strokeWidth="1"
													fill="none"
												>
													<g
														id="Icon-Set"
														transform="translate(-152.000000, -515.000000)"
														fill="#000000"
													>
														<path
															d="M171,525 C171.552,525 172,524.553 172,524 L172,520 C172,519.447 171.552,519 171,519 C170.448,519 170,519.447 170,520 L170,524 C170,524.553 170.448,525 171,525 L171,525 Z M182,543 C182,544.104 181.104,545 180,545 L156,545 C154.896,545 154,544.104 154,543 L154,519 C154,517.896 154.896,517 156,517 L158,517 L158,527 C158,528.104 158.896,529 160,529 L176,529 C177.104,529 178,528.104 178,527 L178,517 L180,517 C181.104,517 182,517.896 182,519 L182,543 L182,543 Z M160,517 L176,517 L176,526 C176,526.553 175.552,527 175,527 L161,527 C160.448,527 160,526.553 160,526 L160,517 L160,517 Z M180,515 L156,515 C153.791,515 152,516.791 152,519 L152,543 C152,545.209 153.791,547 156,547 L180,547 C182.209,547 184,545.209 184,543 L184,519 C184,516.791 182.209,515 180,515 L180,515 Z"
															id="save-floppy"
														/>
													</g>
												</g>
											</svg>
										</span>
									</span>
								</td>
								<CenteredStatusCell>
									{renderStatus(row.survey_form_status)}
								</CenteredStatusCell>
								<CenteredStatusCell>
									{renderStatus(row.email_notification_status)}
								</CenteredStatusCell>
								<CenteredStatusCell>
									{renderStatus(row.benchmark_push_status)}
								</CenteredStatusCell>
								<td>
									<SendButton onClick={() => handleRowClickData(row)}>
										Configure
									</SendButton>
								</td>
							</tr>
						))}
					</tbody>
				</Table>
				<br />
			</TableContainer>
		</>
	);
};

export default DataTable;
